import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-saved-seguridata',
  templateUrl: './saved-seguridata.component.html',
  styleUrls: ['./saved-seguridata.component.scss'],
})
export class SavedSeguridataComponent {
  @Input() seguridataFormId: string;
  @Input() hideChange: boolean = false;
  @Output() resetSeguridataForm: EventEmitter<void> = new EventEmitter();

  constructor() {}

  onResetSeguridataForm() {
    this.resetSeguridataForm.emit();
  }
}
